var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.9995 13.5C26.9995 6.04425 20.9558 0 13.4995 0C6.04334 0 0 6.04425 0 13.5C0 20.2382 4.93664 25.823 11.3905 26.8349V17.4007H7.96284V13.5H11.3905V10.5255C11.3905 7.14234 13.4057 5.27318 16.4895 5.27318C17.9667 5.27318 19.5116 5.53716 19.5116 5.53716V8.85909H17.8112C16.133 8.85909 15.6109 9.9023 15.6109 10.9677V13.5H19.3533L18.7546 17.4007H15.6091V26.8349C22.0629 25.823 26.9995 20.2382 26.9995 13.5Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
